module.exports = __webpack_public_path__ + "static/img/huarunsanjiu.5864bc62.png";